<div class="d-flex align-items-center justify-content-end text-secondary text-end h-100 py-2">
  <span class="fw-bold">{{ pointsBalance$ | async | FortressCurrencyPipe : 'PTS' }}</span>
</div>
